// On resize end
// ----------------------------------------

(() => {
	let timer;

	$WINDOW.on('resize', function () {
		if (timer) {
			window.clearTimeout(timer);
		}

		timer = window.setTimeout(function () {
			$WINDOW.trigger('resize:end');

			console.log('resize:end');
		}, 250);
	});
})();

// On horizontal resize
// ----------------------------------------

(() => {
	let width = window.innerWidth;

	$WINDOW.on('resize:end', function () {
		if (width == window.innerWidth) return;

		width = window.innerWidth;

		$WINDOW.trigger('resize:horizontal');

		console.log('resize:horizontal');
	});
})();

// Async ForEach
// ----------------------------------------

async function asyncForEach(array, callback) {
	for (let index = 0; index < array.length; index++) {
		await callback(array[index], index, array);
	}
}
